import { NavLink } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import {
    LayoutDashboard,
    FileText,
    GitCompare,
    Settings,
    LogOut,
} from 'lucide-react';
import styles from './Sidebar.module.css';

// Final 4-item navigation per UX restructure spec
const navItems = [
    {
        path: '/app',
        icon: LayoutDashboard,
        label: 'Dashboard',
        exact: true,
    },
    {
        path: '/app/filing',
        icon: FileText,
        label: 'Filing',
    },
    {
        path: '/app/reconcile',
        icon: GitCompare,
        label: 'Reconcile',
    },
    {
        path: '/app/settings',
        icon: Settings,
        label: 'Settings',
    },
];

export default function Sidebar() {
    const { logout } = useAuth();
    return (
        <aside className={styles.sidebar}>
            <div className={styles.logo}>
                <img src="/logo.png" alt="GST AutoPilot" className={styles.logoImage} />
                <h1 className={styles.logoText}>GST AutoPilot</h1>
            </div>

            <nav className={styles.nav}>
                <ul className={styles.navList}>
                    {navItems.map((item) => (
                        <li key={item.path}>
                            <NavLink
                                to={item.path}
                                end={item.exact}
                                className={({ isActive }) =>
                                    `${styles.navLink} ${isActive ? styles.active : ''}`
                                }
                            >
                                <item.icon size={20} />
                                <span>{item.label}</span>
                            </NavLink>
                        </li>
                    ))}
                </ul>
            </nav>

            <div className={styles.footer}>
                <div className={styles.complianceScore}>
                    <div className={styles.scoreHeader}>
                        <span>Compliance Score</span>
                        <span className={styles.scoreValue}>94</span>
                    </div>
                    <div className={styles.scoreBar}>
                        <div className={styles.scoreFill} style={{ width: '94%' }} />
                    </div>
                </div>

                <button className={styles.logoutBtn} onClick={() => { logout(); window.location.href = '/sign-in'; }}>
                    <LogOut size={18} />
                    <span>Logout</span>
                </button>
            </div>
        </aside>
    );
}
